export default "__VITE_ASSET__CsHMC8Z6__"